import cn from "classnames";
import { Datetime, FileField, Select } from "components/shared/form";
import { plainDate } from "helpers/date";
import { createRequestForUploadFile } from "helpers/form";
import React, { useState } from "react";
import { alert } from "services/alert";
import { getOrganizationNames } from "sources/admin";
import { apply, сheckOrganizationRecommendation } from "sources/books/organizationRecommendations";

const RecommendationForm = (props) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});

    const saveData = (e) => {
        e.preventDefault();
        setLoading(true);
        const paramsRequest = createRequestForUploadFile("file", data.file);
        paramsRequest.body.append("organizationId", data.organizationId);
        paramsRequest.body.append("month", plainDate(data.month));
        сheckOrganizationRecommendation({ organizationId: data.organizationId, month: plainDate(data.month) }).then(
            (res) => {
                if (res?.isOk) {
                    apply(paramsRequest).then((result) => {
                        setLoading(false);
                        if (result) {
                            props.mergeParams({});
                            props.back();
                        }
                    });
                } else {
                    if (res.errorMessage) {
                        alert({ type: "error", message: res.errorMessage, title: "Ошибка" });
                    }
                    setLoading(false);
                }
            },
        );
    };

    return (
        <form className={cn({ loading })} onSubmit={saveData}>
            <Select
                label="Организация"
                inputProps={{ name: "organizationId" }}
                url={getOrganizationNames}
                propName="name"
                menuPortalTarget={document.body}
                value={data.organizationId}
                onChange={({ value }) => setData({ ...data, organizationId: value })}
            />
            <Datetime
                inputProps={{ name: "month", type: "custom" }}
                value={data.month}
                onChange={({ value }) => setData({ ...data, month: value })}
                label="Месяц"
                format={{ dateFormat: "LLLL yyyy" }}
                libOptions={{ dateFormat: "LLLL yyyy", showMonthYearPicker: true }}
                inPortal
            />
            <FileField
                label="Файл"
                inputProps={{ name: "file" }}
                value={data.file}
                onChange={({ value }) => setData({ ...data, file: value })}
                accept=".pdf"
            />
            <button className="btn btn-sm btn-brand float-right" type="submit">
                Сохранить
            </button>
        </form>
    );
};

export default RecommendationForm;
